import { type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { i18n } from '@shared/i18n';
import { env } from '@shared/config/env';
import { ToastRoot } from '@shared/ui';
import { queryClient } from './query-client';
import { AuthBootstrap } from './auth-bootstrap';
import { ErrorBoundary } from './error-boundary';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthBootstrap>
              {children}
              <ToastRoot />
            </AuthBootstrap>
          </BrowserRouter>
          {env.isDev ? <ReactQueryDevtools initialIsOpen={false} /> : null}
        </QueryClientProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
}
